import React, { useEffect } from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { useNavigate } from 'react-router-dom';
import { saveRecentActivity } from '../../../../redux/reducers/adminSlice';
import { useDispatch, useSelector } from 'react-redux';

const RecentActivity = ({ contactResolved = 0, feedbackResolved = 0, enquiryResolved = 0 }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const recentActivity = useSelector((state) => state.admin.recentActivity);

    // useEffect(() => {
    //     let activityObj = {
    //         'contactForm': Math.max(contactResolved, recentActivity['contactForm'] || 0),
    //         'feedback': Math.max(feedbackResolved, recentActivity['feedback'] || 0),
    //         'product-enquiry': Math.max(enquiryResolved, recentActivity['product-enquiry'] || 0),
    //     }
    //     dispatch(saveRecentActivity(activityObj))
    // }, [contactResolved, feedbackResolved, enquiryResolved])

    const handleRedirection = (path) => {
        // dispatch(saveRecentActivity({ ...recentActivity, [path]: 0 }))
        navigate(`/admin/${path}`)
    }

    return (
        <div className={`eventWrapper`}>
            <div className={`component-title flex items-center`}>
                <div className='label'>Recent Activity</div>
                <div className='vector'></div>
            </div>
            <div className={`eventWrapper ${classes.dashboardCardWrapper}`}>
                <div className={`${classes.dashboardCard} flex items-center cursor-pointer`} onClick={() => handleRedirection('contactForm')}>
                    <div className={`${classes.activityCount} flex items-center justify-center`}>
                        {contactResolved}
                    </div>
                    <div className={`${classes.activityDescription}`}>
                        Resolved Contact Us
                    </div>
                    <div className={`${classes.activityToggle} flex items-center justify-end`}>
                        <ArrowForwardIosSharpIcon />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center cursor-pointer`} onClick={() => handleRedirection('product-enquiry')}>
                    <div className={`${classes.activityCount} flex items-center justify-center`}>
                        {enquiryResolved}
                    </div>
                    <div className={`${classes.activityDescription}`}>
                        Resolved Enquiry
                    </div>
                    <div className={`${classes.activityToggle} flex items-center justify-end`}>
                        <ArrowForwardIosSharpIcon />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center cursor-pointer`} onClick={() => handleRedirection('feedback')}>
                    <div className={`${classes.activityCount} flex items-center justify-center`}>
                        {feedbackResolved}
                    </div>
                    <div className={`${classes.activityDescription}`}>
                        Resolved Feedback
                    </div>
                    <div className={`${classes.activityToggle} flex items-center justify-end`}>
                        <ArrowForwardIosSharpIcon />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default RecentActivity